<script setup lang="ts">
interface Tab {
  name: string
  to: {
    path: string
    hash?: string
  }
  value: string
}
defineProps<{
  companySlug: string
  currentSection: string
  tabs: Tab[]
}>()
</script>

<template>
  <nav class="border-b border-gray-200 bg-white sticky top-[64px] z-40">
    <Container>
      <div class="overflow-x-auto no-scrollbar">
        <div
          class="flex min-w-max justify-center space-x-2 md:space-x-8 px-2"
          aria-label="Tabs"
        >
          <NuxtLink
            v-for="tab in tabs"
            :key="tab.value"
            :to="tab.to"
            :class="[
              currentSection === tab.value
                ? 'border-primary-500 text-primary-600 bg-primary-100/50'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 hover:bg-primary-100/50',
              'whitespace-nowrap border-b-2 py-4 px-2 md:px-4 text-[14px] md:text-[18px] font-medium transition-all duration-200'
            ]"
          >
            {{ tab.name }}
          </NuxtLink>
        </div>
      </div>
    </Container>
  </nav>
</template>

<style>
:root {
  --banner-height: 0px;
}
@media (max-width: 768px) {
  :root {
    --banner-height: 0px;
  }
}
</style>
